import React, { useState } from 'react';
import { Row, Col, Label, Input, FormGroup, Button, Card, CardBody, Badge, Table, CardHeader, Collapse } from 'reactstrap';
import uuid from 'react-uuid';
import { FaPlus, FaChevronUp, FaChevronDown } from 'react-icons/fa';
import Moment from 'moment';
import { ToastContainer, toast as toastytoast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Tooltip as ReactTooltip } from "react-tooltip";

const WholeFarmActionView = ({ handleOpenWholeActionPopup, outlineCenter, open, showArrow }) => {
    const roleName = localStorage.getItem("roleName");
    const isCreateNewAction = localStorage.getItem("isCreateNewAction");
    const [isOpen, setIsOpen] = useState(open);
    const [isIconUp, setIsIconUp] = useState(false);
    const toggle = () => {
        setIsOpen(!isOpen);
        setIsIconUp(!isIconUp);
    };
    const openActionCount = outlineCenter.actions.filter(action => action.isCloseout != true).length;
    const closedActionCount = outlineCenter.actions.filter(action => action.isCloseout == true).length;
    const [isClosedActionShow, setIsClosedActionShow] = useState(false);
    const handleClosedActionShow = (event) => {
        setIsClosedActionShow(event.target.checked);
    }

    const CustomToastWithLink = () => (
        <div>
            <p>The first form is where you can select, from a drop-down, what risk or risks the action will be mitigating. After you’ve selected the risk, a secondary form will open, and you can complete what land units this action will take place on. In addition, you can choose from a drop-down of possible actions to mitigate this risk. When you’ve chosen an action click on select and you’ll be taken back to the primary form. It will now show your selections and you can complete the additional information and “Save.”</p>
        </div>
    );
    const customId = "custom-id-yes1";
    const showToastMessage = (e) => {
        e.stopPropagation();
        toastytoast.info(CustomToastWithLink, {
            autoClose: false, theme: "colored", hideProgressBar: true, icon: false, toastId: customId, rtl: false
        });
    };

    return (
            <Card className="card-header-outline">
                {showArrow && <CardHeader className="card-header-click" onClick={toggle}>
                    <Row>
                        <Col sm="11">
                        <h5>Actions - entire property
                            {openActionCount > 0 ?
                                <span className="risk-badge">
                                | <Badge color="primary">
                                        {openActionCount}
                                    </Badge> <span className="card-header-label-xs">Open Action(s)</span>
                                </span> :
                                <></>}&nbsp;&nbsp;&nbsp;
                            <img className="featureIcon" src="/images/info_button_dk.png" data-tooltip-id="my-tooltip-27" onClick={(e) => e.stopPropagation()} />
                        </h5>
                        <ReactTooltip opacity="1" className="overrideMe" globalCloseEvents={{ escape: true, clickOutsideAnchor: true, scroll: true, resize: true }} openOnClick="true" clickable="true" style={{ marginTop: "-1vh", backgroundColor: "#e2f2f3", color: "black", maxWidth: "25vw", fontWeight: "750", wordBreak: 'normal', overflowWrap: 'break-word' }}
                            id="my-tooltip-27"
                            place="top"
                            variant="info"
                            render={({ content, activeAnchor }) => (
                                <>
                                    <Row>
                                        <Col>
                                            <p style={{ fontWeight: "lighter" }}>
                                                For more information on how to create and close actions <a href="https://freshwaterfarmplan.co.nz/support-category/actions/" target="_blank" rel="noreferrer">Click Here</a>
                                            </p>
                                        </Col>
                                    </Row>
                                </>
                            )}
                        />
                        </Col>
                        <Col sm="1" className="toggleoutline_lt">{isIconUp ? <FaChevronUp /> : <FaChevronDown />}</Col>
                    </Row>
                </CardHeader>}
            <Collapse isOpen={isOpen}>
                <CardBody>
                        <Row className="my-3">
                            <Col>
                                {
                                    closedActionCount > 0 ?
                                        <FormGroup check inline className="float-end">
                                            <Input
                                                type="checkbox"
                                                name="isClosedActionShow"
                                                id="isClosedActionShow"
                                                checked={isClosedActionShow}
                                                onChange={handleClosedActionShow}
                                            />
                                            <Label htmlFor="isClosedActionShow" check> Show Closed Actions <Badge>{closedActionCount}</Badge></Label>
                                        </FormGroup> : ''
                                }

                                {
                                    outlineCenter.actions.length != 0 &&
                                    <>
                                        <table className="table borderless">
                                            <thead></thead>
                                            <tbody>
                                                <tr className="actions-table" key={uuid()}>
                                                    <td >
                                                        <Table className='table borderless '>
                                                            <thead >
                                                                <tr>
                                                                    <th> # </th>
                                                                    <th style={{ textAlign: 'center' }}> Category </th>
                                                                    <th style={{ width: '10%' }}> Due </th>
                                                                    <th style={{ width: '20%' }}> Risk(s) </th>
                                                                    <th style={{ width: '20%' }}> Title  </th>
                                                                    <th style={{ width: '30%' }}> Details </th>
                                                                    <th></th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {
                                                                    outlineCenter.actions.map(action =>

                                                                        <tr key={action.id} className={"" + (action.isCloseout === true ? "closedAction" : "openAction") + " " + (!isClosedActionShow && action.isCloseout === true ? "closed-hidden" : "")}>
                                                                            <td> {action.id} </td>
                                                                            <th scope="row" style={{ textAlign: 'center' }}>{action.category == null ? "" : <Badge color="danger">{action.category}</Badge>}  </th>
                                                                            <td> {action.actionType == 46 ? "Ongoing / Management" : Moment(action.dueDate).format('DD/MM/YYYY')} </td>
                                                                            <td> {action.riskName}</td>
                                                                            <td> {action.title} </td>
                                                                            <td> {action.description} </td>
                                                                            <td> {action.isCloseout !== true ?
                                                                                <Button className="text-end" color="warning" size="sm" onClick={(itemId, actionId) => handleOpenWholeActionPopup(outlineCenter.itemId, action.id)} > Edit </Button> :
                                                                                <Button className="text-end" color="primary" size="sm" onClick={(itemId, actionId) => handleOpenWholeActionPopup(outlineCenter.itemId, action.id)} > View </Button>}
                                                                            </td>
                                                                        </tr>
                                                                    )}
                                                            </tbody>
                                                        </Table>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </>
                                }
                            </Col>
                    </Row>
                        <Row style={{ marginTop: "-2.5vh" }}>
                            <Col sm="8">
                            </Col>
                            <Col sm="4">
                                {(roleName == 'Admin' || isCreateNewAction == 'true') &&
                                    <>
                                        <Button className="btn-items-actions" color="success" size="sm" onClick={(itemId, actionId) => handleOpenWholeActionPopup(outlineCenter.itemId, 0)} >
                                            <FaPlus /> Action
                                        </Button>
                                    </>
                                }
                            </Col>
                        </Row>
                    </CardBody>
                </Collapse>
            </Card>
    )
}
export default WholeFarmActionView